export const lockScreenIllustration =
  "/resources/lock-screen-illustration.webp";
